import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

import resources from '@assets/translations'

void i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en-US',
        lng: 'en-US',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
        resources,
    })

export default i18n
